import React from 'react';

import { DetailsTooltipStyles } from '~src/spacesPlatform/components/card/DetailsTooltipStyles';

export interface BasicFieldProps {
  name: string;
  value: any;
}

export function BasicField(props: BasicFieldProps) {
  if (props.value) {
    return (
      <div className={DetailsTooltipStyles.MetadataSection}>
        <span className={DetailsTooltipStyles.MetadataTitle}>{props.name}</span>
        <span className={DetailsTooltipStyles.MetadataValue}>{props.value}</span>
      </div>
    );
  } else {
    return null;
  }
}
